import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class QuantityCellEditorService {
  // Si devient problématique, pourrait être en relation avec un groupe. Ex. Record<string, BehaviorSubject>
  $editingEditor: BehaviorSubject<string> = new BehaviorSubject<string>(null);

  editingStarted(id: string) {
    if (this.$editingEditor.value !== id) {
      console.log(`Editor requested edit state.`, id);
      this.$editingEditor.next(id);
    }
  }

  editingDone(id: string) {
    if (this.$editingEditor.value === id) {
      console.log(`Editor is done with edit state.`, id);
      this.$editingEditor.next(null);
    }
  }
}
